























import { PropType } from 'vue';
import { PopupNovo, popups_visualizados } from '~/store/popup-novo';




export default {
    emits: ['close'],
    props: {
        record: {
            type: Object as PropType<PopupNovo>,
            required: true
        }
    },
    data() {
        return {
            nao_exibir_novamente: false
        }
    },
    mounted() {
        const el = this.$el as HTMLDialogElement

        if (!el) {
            return
        }
        el.showModal()

    },
    methods: {
        close() {
            popups_visualizados.value.push(this.record.id)
            if (this.nao_exibir_novamente) {
                let ids = JSON.parse(localStorage.getItem('popup-novos-visualizados') || '[]') || []
                ids.push(this.record.id)
                localStorage.setItem('popup-novos-visualizados', JSON.stringify(ids))
            }
            this.$emit('close')
        }
    }
}
